import React  from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import TenantEnableSubscriptionInfoComponent from './tenant-enable-subscription-info.component';

export const EnableSubscriptionComponent = ({enableSubscription,programs, handleInnerFormChange, back,handleFormSubmit }: any) => {
  const tabItems=[
    {
        id:1,
        title:'Enable Subscription',
        component:<TenantEnableSubscriptionInfoComponent
        programs={programs} 
        enableSubscription={enableSubscription}
        handleInnerFormChange={handleInnerFormChange}
        />,
    isVisible:true,
    },
  ]
   
  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
      <TabContainer tabItems={tabItems}/>
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
              onClick={handleFormSubmit}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Save
             </button>
        </div>
       </div>
  )
}
export default EnableSubscriptionComponent;